<template>
  <div class="home-universally-mian">
    <span class="dynamic-public dynamic-lines"></span>
    <span class="dynamic-public dynamic-lines dynamic-rotate"></span>
    <span class="dynamic-public dynamic-lines2"></span>
    <span class="dynamic-public dynamic-lines3"></span>

    <i class="ico-top ico-top-left"> </i>
    <i class="ico-top ico-top-right"> </i>
    <i class="ico-top ico-bottom-left"> </i>
    <i class="ico-top ico-bottom-right"> </i>

    <div :class="['title-mian', defineCl]" ref="rriskLeftTotalId">
      <span class="title-name" ref="rriskLeftNameId" @click="toDetail">{{ name }}</span>
      <div class="title-right" ref="rriskLeftId">
        <img class="title-ico" v-if="offsetWidth && offsetWidth >= 1278"
          src="../../assets/homeNew/content5_1278_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 1008"
          src="../../assets/homeNew/content5_1008_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 960"
          src="../../assets/homeNew/content5_960_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 840"
          src="../../assets/homeNew/content5_840_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 720"
          src="../../assets/homeNew/content5_720_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 640"
          src="../../assets/homeNew/content5_640_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 520"
          src="../../assets/homeNew/content5_520_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 400"
          src="../../assets/homeNew/content5_400_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 300"
          src="../../assets/homeNew/content5_300_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 212"
          src="../../assets/homeNew/content5_212_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 200"
          src="../../assets/homeNew/content5_200_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 162"
          src="../../assets/homeNew/content5_162_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 150"
          src="../../assets/homeNew/content5_150_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 130"
          src="../../assets/homeNew/content5_130_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 100"
          src="../../assets/homeNew/content5_100_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 80"
          src="../../assets/homeNew/content5_80_15.png" />
        <img class="title-ico" v-else-if="offsetWidth && offsetWidth >= 50"
          src="../../assets/homeNew/content5_60_15.png" />
        <!--<img class="title-ico2" v-else src="../../assets/homeNew/content5_150_15.png" />-->
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '-'
    },
    ico: {
      type: String,
      default: ''
    },
    defineCl: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      offsetWidth: 0,
      rriskLeftTotal: 0,
      rriskLeftName: 0,
    }
  },
  watch: {

  },
  created() {
    let _this = this
    window.addEventListener('resize', () => { //监听浏览器大小去改变图表尺寸  
      _this.calculateTorm()
    })
    setTimeout(() => {
      _this.calculateTorm()
    }, 300)
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    calculateTorm() {
      let _this = this
      if (_this.$refs['rriskLeftId']) {
        _this.calculateWidth()
      } else {
        setTimeout(() => {
          if (_this.$refs['rriskLeftId']) {
            _this.calculateWidth()
          } else {
            setTimeout(() => {
              if (_this.$refs['rriskLeftId']) {
                _this.calculateWidth()
              }
            }, 1000)
          }
        }, 500)
      }
    },
    calculateWidth() {
      let _this = this
      if (_this.$refs['rriskLeftTotalId'] && _this.$refs['rriskLeftNameId']) {
        let rriskLeftTotal = _this.$refs['rriskLeftTotalId'].offsetWidth
        let rriskLeftName = _this.$refs['rriskLeftNameId'].offsetWidth

        if (isNaN(Number(rriskLeftTotal))) {
          rriskLeftTotal = 0
        }
        if (isNaN(Number(rriskLeftName))) {
          rriskLeftName = 0
        }

        if (rriskLeftName >= rriskLeftTotal) {
          rriskLeftName = rriskLeftTotal
        }

        let offsetWidth = rriskLeftTotal - rriskLeftName

        if (offsetWidth >= 20) {
          offsetWidth = offsetWidth - 20
        }
        _this.offsetWidth = offsetWidth

        _this.rriskLeftTotal = rriskLeftTotal
        _this.rriskLeftName = rriskLeftName

      }

    },

    toDetail() {
      this.$router.push({
        path: this.href
      })
    }

  }
}
</script>

<style lang="scss" scoped>


.home-universally-mian  .dynamic-public {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: none;
  box-sizing: border-box;

}


.home-universally-mian  .dynamic-lines:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  background: #65D4FF;
  animation: animate 5s linear infinite;
}


.home-universally-mian  .dynamic-rotate {
  transform: rotate(180deg);
}

.home-universally-mian  .dynamic-lines2:before {
  content: '';
  position: absolute;
  width: 2px;
  height: 100%;
  background: #65D4FF;
  animation: animate2 5s linear infinite;
}

.home-universally-mian  .dynamic-lines3:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  background: #65D4FF;
  animation: animate3 5s linear infinite;
}

@keyframes animate {
  0% {
    transform: scaleX(0);
    transform-origin: left;
  }

  50% {
    transform: scaleX(1);
    transform-origin: left;
  }

  50.1% {
    transform: scaleX(1);
    transform-origin: right;

  }

  100% {
    transform: scaleX(0);
    transform-origin: right;

  }
}
 

@keyframes animate2 {
  0% {
    transform: scaleY(0);
    transform-origin: bottom;
  }

  50% {
    transform: scaleY(1);
    transform-origin: bottom;
  }

  50.1% {
    transform: scaleY(1);
    transform-origin: top;

  }

  100% {
    transform: scaleY(0);
    transform-origin: top;

  }
}


@keyframes animate3 {
  0% {
    transform: scaleY(0);
    transform-origin: top;
  }

  50% {
    transform: scaleY(1);
    transform-origin: top;
  }

  50.1% {
    transform: scaleY(1);
    transform-origin: bottom;

  }

  100% {
    transform: scaleY(0);
    transform-origin: bottom;

  }
}

.home-universally-mian {
  width: 100%;

  .ico-top {
    position: absolute;
    width: 22px;
    height: 19px;
    display: block;
  }

  .ico-top-left {
    left: 0;
    top: 0;
    background-image: url('../../assets/homeNew/content3.png');
    background-size: 100% 100%;
  }

  .ico-top-right {
    right: 0;
    top: 0;
    background-image: url('../../assets/homeNew/content14.png');
    background-size: 100% 100%;
  }

  .ico-bottom-left {
    left: 0;
    bottom: 0;
    background-image: url('../../assets/homeNew/content15.png');
    background-size: 100% 100%;
  }

  .ico-bottom-right {
    right: 0;
    bottom: 0;
    background-image: url('../../assets/homeNew/content16.png');
    background-size: 100% 100%;
  }


  .title-mian {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 30px;

    .title-name {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #65D4FF;
      cursor: pointer;
    }

    .title-right {
      position: relative;
      flex: 1;
      margin-left: 20px;
      height: 15px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title-ico {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        height: 100%;
      }

      .title-ico2 {
        width: 100%;
        display: block;
      }


    }


  }

  .title-mian2 {
    padding-bottom: 5px;
  }

  .title-mian10 {
    padding-bottom: 10px;
  }

  .title-mian15 {
    padding-bottom: 15px;
  }

  .title-mian20 {
    padding-bottom: 20px;
  }


}


@media screen and (max-width: 1600px) {
  .home-universally-mian {
    .title-mian {

      .title-name {
        font-size: 20px;
      }
    }
  }
}
</style>
